import { useState, useEffect, useCallback } from 'react'
import { supabase } from '../lib/supabase'

export function useUserProfile(userId) {
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!userId) { setLoading(false); return }

    const fetch = async () => {
      const { data } = await supabase
        .from('user_profiles')
        .select('theme')
        .eq('id', userId)
        .maybeSingle()

      if (data) {
        setProfile(data)
      } else {
        // Row may not exist yet — create it with direct write (not queued).
        // 'blocks' is the default OS experience (color-coded Block nav).
        await supabase
          .from('user_profiles')
          .upsert({ id: userId, theme: 'blocks' }, { onConflict: 'id' })
        setProfile({ theme: 'blocks' })
      }
      setLoading(false)
    }

    fetch()
  }, [userId])

  // Direct write — bypasses the offline queue so the preference is always
  // persisted immediately, even right before the user logs out.
  const updateTheme = useCallback(async (newTheme) => {
    if (!userId) return
    setProfile(prev => ({ ...prev, theme: newTheme }))   // optimistic
    const { error } = await supabase
      .from('user_profiles')
      .update({ theme: newTheme, updated_at: new Date().toISOString() })
      .eq('id', userId)
    if (error) console.warn('[useUserProfile] theme update failed:', error.message)
  }, [userId])

  return { profile, loading, updateTheme }
}
